(ns accounts.common
  (:require
    [reagent.format :as fmt]
    [very.re-frame.core :as rf]
    [css.core :refer [defstyled]]
    [css.typography :as typo]
    [css.icons :as icon]
    [css.vars :as vars]
    [cljss.core :as cljss]))

(defstyled colored-gain-or-loss-s :label
  {:color (with-meta #(cond
                        (> % 0) vars/green
                        (< % 0) vars/red
                        :else vars/text) :value)
   :font-weight (with-meta #(or % "normal") :font-weight)})

(defn percent-fmt [x]
  ((fnil #(fmt/format "%.2f%" %) 0) x))

(defstyled modal-header-s :header
  {:align-items "center"
   :display "flex"
   :flex-direction "column"
   :justify-content "center"
   :position "relative"
   :margin-bottom "2rem" :foo "123"})

(defstyled icon-wrapper-s :div
  {:border-bottom (str "1px solid " vars/border-light)
   :padding-bottom "1rem"
   :justify-content "flex-end"
   :display "flex"
   :margin "1rem"
   :width "calc(100% - 2rem)"})

(defstyled cancel-i-s :i
  {:cursor "pointer"
   :width "2rem"
   :height "2rem"
   :background "url(/assets/icons/close.svg) no-repeat center"
   :background-size "2rem"})

(defn- modal-header [title on-cancel]
  [modal-header-s
   [icon-wrapper-s
    [cancel-i-s {:on-click on-cancel}]]
   [typo/h3 title]])

(defstyled modal-with-header-s :div
  {:display "grid"
   :grid-template-rows "auto 1fr"})

(defstyled modal-header-content-s :div
  {:display "grid"})

(defstyled medium-down-s :div
  {:display "none"
   ::cljss/media {[[:max-width "768px"]]
                  {:display "block"}}})

(defn modal-with-header [{:keys [title on-cancel]} & content]
  [modal-with-header-s
   [modal-header title on-cancel]
   (apply conj [modal-header-content-s] content)])
